module.exports = __webpack_public_path__ + "static/media/button.7501b36e.svg";